module.exports = __webpack_public_path__ + "img/Logo.55d597c9.png";